import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Switch, Input, InputNumber, Modal } from 'antd';
import './NoticeManage.less';
import { Btn } from '../../components/Widgets';

class NoticeManage extends PureComponent {
  render() {
    const { dispatch, noticeConfig = {}, noticeKeys = [], maxDelayTime = '15|30|60', infraredCheckTime, intl ,billingSwitch = 0, crossDaysMeetingMinDay = 1, meetingReserveTimeRange = 30} = this.props;
    let globalSmsChecked = !!noticeConfig.globalSmsState,
      globalEmailChecked = !!noticeConfig.globalEmailState,
      globalVskChecked = !!noticeConfig.globalVskState,
      globalWechatChecked = !!noticeConfig.globalWechatState,
      globalDingTalkChecked = !!noticeConfig.globalDingTalkState,
      userSmsChecked = !!noticeConfig.userSmsState,
      userEmailChecked = !!noticeConfig.userEmailState,
      userVskChecked = !!noticeConfig.userVskState,
      userWechatChecked = !!noticeConfig.userWechatState,
      userDingTalkChecked = !!noticeConfig.userDingTalkState;
    return (
      <div className="notice-manage">
        <div className="notice-title">
          <span className="search-line-title">
            <FormattedMessage id="notice_manage_global_config"/>
          </span>
          <span className="search-line-subtitle">
            <FormattedMessage id="notice_manage_global_config_content"/>
          </span>
        </div>
        <div className="notice-content">
          {noticeKeys.indexOf('smsState') > -1 ? (
            <div className="notice-item">
              <label>
                <FormattedMessage id="notice_manage_sms"/> :{' '}
              </label>
              <div className="notice-control">
                <Switch
                  checked={globalSmsChecked}
                  onChange={value => {
                    dispatch({
                      type: 'account/updateNoticeConfig',
                      noticeConfig: {
                        ...noticeConfig,
                        globalSmsState: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          ) : null}
          {noticeKeys.indexOf('emailState') > -1 ? (
            <div className="notice-item">
              <label>
                <FormattedMessage id="notice_manage_email"/> :{' '}
              </label>
              <div className="notice-control">
                <Switch
                  checked={globalEmailChecked}
                  onChange={value => {
                    dispatch({
                      type: 'account/updateNoticeConfig',
                      noticeConfig: {
                        ...noticeConfig,
                        globalEmailState: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          ) : null}
          {noticeKeys.indexOf('vskMsgState') > -1 ? (
            <div className="notice-item">
              <label>
                <FormattedMessage id="notice_manage_vsk"/> :{' '}
              </label>
              <div className="notice-control">
                <Switch
                  checked={globalVskChecked}
                  onChange={value => {
                    dispatch({
                      type: 'account/updateNoticeConfig',
                      noticeConfig: {
                        ...noticeConfig,
                        globalVskState: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          ) : null}
          {noticeKeys.indexOf('weiXinState') > -1 ? (
            <div className="notice-item">
              <label>
                <FormattedMessage id="notice_manage_wechat"/> :{' '}
              </label>
              <div className="notice-control">
                <Switch
                  checked={globalWechatChecked}
                  onChange={value => {
                    dispatch({
                      type: 'account/updateNoticeConfig',
                      noticeConfig: {
                        ...noticeConfig,
                        globalWechatState: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          ) : null}
          {noticeKeys.indexOf('ddMsgState') > -1 ? (
            <div className="notice-item">
              <label>
                <FormattedMessage id="notice_manage_dd"/> :{' '}
              </label>
              <div className="notice-control">
                <Switch
                  checked={globalDingTalkChecked}
                  onChange={value => {
                    dispatch({
                      type: 'account/updateNoticeConfig',
                      noticeConfig: {
                        ...noticeConfig,
                        globalDingTalkState: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          ) : null}
        </div>
        <div className="notice-title">
          <span className="search-line-title">
            <FormattedMessage id="notice_manage_user_notice_config"/>
          </span>
          <span className="search-line-subtitle">
            <FormattedMessage id="notice_manage_user_notice_config_content"/>
          </span>
        </div>
        <div className="notice-content">
          {noticeKeys.indexOf('smsState') > -1 ? (
            <div className="notice-item">
              <label>
                <FormattedMessage id="notice_manage_sms"/> :{' '}
              </label>
              <div className="notice-control">
                <Switch
                  checked={userSmsChecked}
                  onChange={value => {
                    dispatch({
                      type: 'account/updateNoticeConfig',
                      noticeConfig: {
                        ...noticeConfig,
                        userSmsState: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          ) : null}
          {noticeKeys.indexOf('emailState') > -1 ? (
            <div className="notice-item">
              <label>
                <FormattedMessage id="notice_manage_email"/> :{' '}
              </label>
              <div className="notice-control">
                <Switch
                  checked={userEmailChecked}
                  onChange={value => {
                    dispatch({
                      type: 'account/updateNoticeConfig',
                      noticeConfig: {
                        ...noticeConfig,
                        userEmailState: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          ) : null}
          {false && noticeKeys.indexOf('vskMsgState') > -1 ? (
            <div className="notice-item">
              <label>
                <FormattedMessage id="notice_manage_vsk"/> :{' '}
              </label>
              <div className="notice-control">
                <Switch
                  checked={userVskChecked}
                  onChange={value => {
                    dispatch({
                      type: 'account/updateNoticeConfig',
                      noticeConfig: {
                        ...noticeConfig,
                        userVskState: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          ) : null}
          {false && noticeKeys.indexOf('weiXinState') > -1 ? (
            <div className="notice-item">
              <label>
                <FormattedMessage id="notice_manage_wechat"/> :{' '}
              </label>
              <div className="notice-control">
                <Switch
                  checked={userWechatChecked}
                  onChange={value => {
                    dispatch({
                      type: 'account/updateNoticeConfig',
                      noticeConfig: {
                        ...noticeConfig,
                        userWechatState: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          ) : null}
          {false && noticeKeys.indexOf('ddMsgState') > -1 ? (
            <div className="notice-item">
              <label>
                <FormattedMessage id="notice_manage_dd"/>:{' '}
              </label>
              <div className="notice-control">
                <Switch
                  checked={userDingTalkChecked}
                  onChange={value => {
                    dispatch({
                      type: 'account/updateNoticeConfig',
                      noticeConfig: {
                        ...noticeConfig,
                        userDingTalkState: value ? 1 : 0
                      }
                    });
                  }}
                />
              </div>
            </div>
          ) : null}
        </div>
        <div className="notice-title">
          <span className="search-line-title">
            <FormattedMessage id="system_manage_delay_time_config"/>
          </span>
          <span className="search-line-subtitle">
            <FormattedMessage id="system_manage_delay_time_config_content"/>
          </span>
        </div>
        <div className="notice-content">
          <div className="notice-item">
            <label>
              <FormattedMessage id="system_manage_delay_time"/>:{' '}
            </label>
            <div className="notice-control">
              <Input value={maxDelayTime} maxLength="15"
                     onChange={e => {
                       dispatch({ type: 'account/update', payload: { maxDelayTime: e.target.value } });
                     }}/>
            </div>
            <FormattedMessage id="system_manage_delay_time_desc"/>
          </div>
          <div className="operate_btn_div">
            <Btn
              primary
              onClick={() => {
                if (!maxDelayTime) {
                  Modal.warning({ content: '延长时长不能为空!' });
                  return;
                }
                const timeArray = maxDelayTime.split('|');
                if (timeArray.length > 3) {
                  Modal.warning({ content: '延长时长配置最多不超过3个!' });
                  return;
                }
                let isAllNumber = true;
                timeArray.map((time) => {
                  if (isNaN(time) || time < 1) {
                    isAllNumber = false;
                  }
                });
                if (!isAllNumber) {
                  Modal.warning({ content: '延长时长配置错误!' });
                  return;
                }
                let isOrder = true;
                timeArray.map((time, i) => {
                  if (i > 0 && Number(time) <= Number(timeArray[i - 1])) {
                    isOrder = false;
                  }
                });
                if (!isOrder) {
                  Modal.warning({ content: '延长时长应按照从小到大顺序排列!' });
                  return;
                }
                if (timeArray[0] < 15) {
                  Modal.warning({ content: '延长时长不能小于15分钟!' });
                  return;
                }
                if (timeArray[timeArray.length - 1] >= 1000) {
                  Modal.warning({ content: '延长时长不能超过999分钟!' });
                  return;
                }
                dispatch({ type: 'account/saveMaxDelayTime' });
              }}
            >
              <FormattedMessage id="policy_manage_btn_save"/>
            </Btn>
          </div>
        </div>
        <div className="notice-title">
          <span className="search-line-title">
            <FormattedMessage id="system_manage_infrared_check_time_title"/>
          </span>
          <span className="search-line-subtitle">
            <FormattedMessage id="system_manage_infrared_check_time_desc"/>
          </span>
        </div>
        <div className="notice-content">
          <div className="notice-item">
            <label>
              <FormattedMessage id="system_manage_infrared_check_time_pre"/>
            </label>
            <div className="notice-control">
              <InputNumber min={1} max={9999} step={1} value={infraredCheckTime}
                           onChange={val => {
                             if (!isNaN(val)) {
                               dispatch({ type: 'account/update', payload: { infraredCheckTime: Math.floor(val) } });
                             }
                           }}/>
            </div>
            <FormattedMessage id="booking_minutes"/>
          </div>
          <div className="operate_btn_div">
            <Btn
              primary
              onClick={() => {
                if (isNaN(infraredCheckTime) || !infraredCheckTime) {
                  Modal.error({ content: intl.formatMessage({ id: 'system_manage_infrared_check_time_warn' }) });
                  return;
                }
                dispatch({ type: 'account/saveInfraredCheckTime' });
              }}
            >
              <FormattedMessage id="policy_manage_btn_save"/>
            </Btn>
          </div>
        </div>
        <div className="notice-title">
          <span className="search-line-title">
            <FormattedMessage id="notice_manage_title_crossday_meeting_min_day"/>
          </span>
          <span className="search-line-subtitle">
            <FormattedMessage id="notice_manage_subtitle_crossday_meeting_min_day"/>
          </span>
        </div>
        <div className="notice-content">
          <div className="notice-item">
            <label>
              <FormattedMessage id="notice_manage_label_crossday_meeting_min_day"/>
            </label>
            <div className="notice-control">
              <InputNumber min={1} max={9999} step={1} value={crossDaysMeetingMinDay}
                           onChange={val => {
                             if (!isNaN(val)) {
                               dispatch({ type: 'account/update', payload: { crossDaysMeetingMinDay: val } });
                             }
                           }}/>
            </div>
            <FormattedMessage id="unit_day"/>
          </div>
          <div className="operate_btn_div">
            <Btn
              primary
              onClick={() => {
                dispatch({ type: 'account/saveOrUpdatePolicyItem',key:'crossDaysMeetingMinDay',value: crossDaysMeetingMinDay });
              }}
            >
              <FormattedMessage id="policy_manage_btn_save"/>
            </Btn>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { noticeConfig = [], noticeKeys = [], maxDelayTime = '15|30|60', infraredCheckTime, billingSwitch = 0 ,crossDaysMeetingMinDay = 1, meetingReserveTimeRange} = state.account;
  return { noticeConfig, noticeKeys, maxDelayTime, infraredCheckTime ,billingSwitch, crossDaysMeetingMinDay, meetingReserveTimeRange};
};

export default connect(mapStateToProps)(injectIntl(NoticeManage));



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/NoticeManage.js